import { useState, useEffect } from "react";
export default function useCountdown(totalSeconds: number = 60) {
  const [counter, setCounter] = useState(totalSeconds);
  const reset = () => {
    setCounter(totalSeconds);
  };
  useEffect(() => {
    const interval = setInterval(() => {
      counter > 0 && setCounter(time => time - 1);
    }, 1000);
    return () => clearInterval(interval);
  }, [counter]);
  const minutes = Math.floor(counter / 60);
  const seconds = counter % 60;
  return {
    counter: counter > 0 ? `${minutes}:${seconds < 10 ? "0" : ""}${seconds}` : false,
    reset
  };
}